
import React from 'react';
import {Form, Select } from 'antd';

export default function SitemapChangeFreqInput(initialValue, getFieldDecorator, formItemLayout, hideDetails, field = null, update = null) {
    const SitemapChangeFreq = <Select
    onSelect={(value, option)=>{update ? update(value, field) : null}}
    placeholder="انتخاب دوره نقشه سایت" style={{width: '200px'}}>
        {[
            { id: 'always', name: 'همیشه' },
            { id: 'hourly', name: 'ساعتی' },
            { id: 'daily', name: 'روزانه' },
            { id: 'weekly', name: 'هفته ای' },
            { id: 'monthly', name: 'ماهانه' },
            { id: 'yearly', name: 'سالانه' },
            { id: 'never', name: 'هیچ وقت' }
        ].map(s => <Select.Option value={s.id.toString()} key={`ss__${s.id}`}>{s.name}</Select.Option>)}
    </Select>;

    return <Form.Item
    {...formItemLayout}
    label="دوره نقشه سایت"
    hidden={hideDetails}
    colon={false}>
        {getFieldDecorator('sitemap_change_freq', {
            initialValue: initialValue,
        })(
            SitemapChangeFreq
        )}
    </Form.Item>;
}


// WEBPACK FOOTER //
// ./src/components/SitemapChangeFreqInput.js